// Tiny conditional class-name joiner used by the shared login components.
// -----------------------------------------------------------------------------
// Mirrors the behaviour of the website's useClassName / ow-app's UiUtils.ClassNames
// without depending on either app.
export const cx = (
  conditions: Record<string, boolean>,
  defaultClassName = '',
): string => {
  const active = Object.keys(conditions).filter((key) => conditions[key]);
  return [defaultClassName, ...active].filter(Boolean).join(' ');
};
